// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"dd31006766--wrapper--1lwLc","title":"dd31006766--title--31Fph","divider":"dd31006766--divider--2fCE1"};